/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Ac_4Inputs */

const en_pc_cmp_ac_4 = /** @type {(inputs: Pc_Cmp_Ac_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your company requires vendor support, compliance certifications or mobile apps.`)
};

const zh_pc_cmp_ac_4 = /** @type {(inputs: Pc_Cmp_Ac_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公司要求厂商技术支持、合规认证或移动端应用。`)
};

/**
* | output |
* | --- |
* | "Your company requires vendor support, compliance certifications or mobile apps." |
*
* @param {Pc_Cmp_Ac_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_ac_4 = /** @type {((inputs?: Pc_Cmp_Ac_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Ac_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_ac_4(inputs)
	return zh_pc_cmp_ac_4(inputs)
});
export { pc_cmp_ac_4 as "pc.cmp.ac.4" }